import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-quote-video")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-quote-video")),
  head: () => ({
    meta: [
      { title: "بلوك ٧ — إدارة" },
      { name: "description", content: "تحكّم ببلوك ٧ في الصفحة الرئيسيّة." },
    ],
  }),
});
